import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LuHouse, LuLayoutGrid, LuUserRound } from "react-icons/lu";
import { MdOutlineShoppingCart } from "react-icons/md";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { ShopContext } from "../../Context/ShopContext";
import { WishlistContext } from "../../Context/WishlistContext";

// App-shell bottom tab bar shown only on phones (md:hidden). Desktop keeps
// the existing top nav untouched — this is purely additive for mobile.
const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getTotalCartItems } = useContext(ShopContext);
  const { wishlist, setWishlistOpen } = useContext(WishlistContext);
  const isAuthorized = !!localStorage.getItem("auth-token");
  const cartCount = getTotalCartItems();

  const isActive = (path) =>
    path === "/home" ? location.pathname === "/home" : location.pathname.startsWith(path);

  const tabClass = (active) =>
    `relative flex flex-1 flex-col items-center justify-center gap-0.5 py-1.5 ${
      active ? "text-[var(--brand-primary-600)]" : "text-gray-500"
    }`;

  const ActiveDot = ({ active }) => (
    <span
      className={`absolute top-0.5 w-1 h-1 rounded-full bg-[var(--brand-primary-500)] transition-opacity ${
        active ? "opacity-100" : "opacity-0"
      }`}
    />
  );

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-[var(--brand-primary-100)] shadow-[0_-2px_16px_rgba(124,58,237,0.08)] flex items-stretch"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <Link to="/home" className={tabClass(isActive("/home"))}>
        <ActiveDot active={isActive("/home")} />
        <LuHouse size={20} />
        <span className="text-[10px] font-medium">Home</span>
      </Link>

      <Link to="/collections/all" className={tabClass(isActive("/collections"))}>
        <ActiveDot active={isActive("/collections")} />
        <LuLayoutGrid size={20} />
        <span className="text-[10px] font-medium">Shop</span>
      </Link>

      <button
        type="button"
        onClick={() => setWishlistOpen(true)}
        className={tabClass(false)}
      >
        {wishlist.length > 0 ? (
          <FaHeart size={18} className="text-[var(--brand-primary-600)]" />
        ) : (
          <FiHeart size={18} />
        )}
        <span className="text-[10px] font-medium">Wishlist</span>
        {wishlist.length > 0 && (
          <span className="absolute top-0 right-[28%] bg-pink-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
            {wishlist.length}
          </span>
        )}
      </button>

      <Link to="/cart" className={tabClass(isActive("/cart"))}>
        <ActiveDot active={isActive("/cart")} />
        <MdOutlineShoppingCart size={21} />
        <span className="text-[10px] font-medium">Cart</span>
        {cartCount > 0 && (
          <span className="absolute top-0 right-[28%] bg-green-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
            {cartCount}
          </span>
        )}
      </Link>

      <button
        type="button"
        onClick={() => navigate(isAuthorized ? "/user-profile" : "/login")}
        className={tabClass(isActive("/user-profile") || isActive("/login"))}
      >
        <ActiveDot active={isActive("/user-profile") || isActive("/login")} />
        <LuUserRound size={20} />
        <span className="text-[10px] font-medium">Account</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
